module.exports = __webpack_public_path__ + "static/media/digitalize-success.c114c4dc.svg";